import React, { useState } from 'react';

import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography'
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {
    Paper,
    Collapse,
    FormLabel,
    Chip,
    TextField,
    Grid,
    Switch,
    FormGroup,
    RadioGroup,
    Radio,
    Divider,
    Tooltip,
    IconButton
} from '@material-ui/core/';
import { Help } from '@material-ui/icons';

import { campaignCountries } from '../../Config/countries';
import { NumberOfFollowers } from '../../Config/numberOfFollowers';
import './styles.css';

const interests = [
    'FITNESS',
    'HOME',
    'PARENTING',
    'FOOD_BEVERAGES',
    'FASHION',
    'BEAUTY',
];

const COUNTRY_HELPTEXT = 'Where is your brand fan living?';

export const Profile = ({ updateValue, values, errors, onChange }) => {

    const [expandMoreInfo, setExpandMoreInfo] = React.useState(false);

    const handleChipClick = (chipContent, fieldName) => {
        let newChipContent = values[fieldName];

        if (newChipContent.findIndex((item) => item === chipContent) === -1) {
            newChipContent = [...values[fieldName], chipContent];
        } else {
            newChipContent = newChipContent.filter((item) => item !== chipContent);
        }

        updateValue(newChipContent, fieldName);
    }

    return (

        <div>
            <div className="campaign-step-header">
                <Typography variant="h5">
                    Profile
            </Typography>
            </div>
            <Grid container>
                <Grid item style={{ display: 'flex', alignItems: 'center' }}>
                    <FormLabel component="legend">
                        Country
                </FormLabel>
                </Grid>
                <Grid item style={{ display: 'flex', alignItems: 'center' }}>
                    <Tooltip placement="right" title={COUNTRY_HELPTEXT} >
                        <IconButton aria-label="helptext">
                            <Help />
                        </IconButton>
                    </Tooltip>
                </Grid>
            </Grid>
            <Grid container>
                <Grid item>
                    <div className="profile-container-spacer">
                        <div className="profile-chip-holder">
                            {campaignCountries.map((country) => {

                                return (
                                    <div onClick={(event) => handleChipClick(country, 'selectedCountries')} key={country}>
                                        <Chip
                                            className="profile-chip-item"
                                            label={country}
                                            variant={values.selectedCountries && values.selectedCountries.findIndex((item) => item === country) === -1 ? 'outlined' : 'default'} color="primary" />
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <div className="chips-error" >{errors.selectedCountries ? errors.selectedCountries : ' '}</div>
                </Grid>
            </Grid>
            <Grid container>
                <Grid item>
                    <div className="profile-container-spacer">
                        <FormLabel component="legend">
                            Interests
                            </FormLabel>
                        <div className="profile-chip-holder profile-container-spacer">
                            {interests.map((interest) => {
                                return (
                                    <div onClick={(event) => handleChipClick(interest, 'selectedInterests')} key={interest} >
                                        <Chip
                                            className="profile-chip-item"
                                            label={interest}
                                            variant={values.selectedInterests && values.selectedInterests.findIndex((item) => item === interest) === -1 ? 'outlined' : 'default'} color="primary" />
                                    </div>
                                );

                            })}
                        </div>
                    </div>
                    <div className="chips-error">{errors.selectedInterests ? errors.selectedInterests : ' '}</div>
                </Grid>
            </Grid>
            <div className="profile-container-spacer">
                <FormLabel component="legend">
                    Audience
                </FormLabel>
                <Grid container spacing={4}>
                    <Grid item xs={6} sm={4}>
                        <TextField
                            select
                            fullWidth
                            SelectProps={{
                                native: true
                            }}
                            id="minFolowers"
                            margin="normal"
                            variant="outlined"
                            defaultValue={values.minFolowers}
                            label="Minimum Followers"
                            onChange={onChange}
                        >
                            {NumberOfFollowers.map((option) => {
                                return <option disabled={(+values.maxFolowers !== 100001) && +option.value >= +values.maxFolowers} key={option.label} value={option.value}>
                                    {option.label}
                                </option>
                            }
                            )}
                        </TextField>
                    </Grid>
                    <Grid item xs={6} sm={4}>
                        <TextField
                            select
                            fullWidth
                            SelectProps={{
                                native: true
                            }}
                            id="maxFolowers"
                            margin="normal"
                            label="Maximum Followers"
                            variant="outlined"
                            defaultValue={values.maxFolowers ? values.maxFolowers : 10000}
                            onChange={onChange}
                        >
                            {NumberOfFollowers.map(option => (
                                <option disabled={(+values.minFolowers === 100001 && +option.value !== 100001) || +option.value <= +values.minFolowers} key={option.label} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </TextField>
                    </Grid>
                </Grid>
            </div>
            <div style={{ display: 'flex', cursor: 'pointer' }} onClick={() => setExpandMoreInfo(!expandMoreInfo)}>
                <div className={expandMoreInfo ? 'profile-additional-info' : 'profile-additional-info-upside-down'} >
                    <ExpandMoreIcon fontSize="large" />
                </div>
                <div style={{ margin: 'auto auto auto 16px' }}>
                    <FormLabel component="legend">
                        Additional Options
                </FormLabel>
                </div>
            </div>
            <Collapse in={expandMoreInfo}>
                <TextField
                    id="additionalInfo"
                    value={values.additionalInfo}
                    onChange={onChange}
                    fullWidth
                    margin="normal"
                    variant="outlined"
                    label="Other characteristics you'd like to include?"
                    error={!!errors.additionalInfo}
                    multiline
                    autoFocus
                    helperText={errors.additionalInfo ? errors.additionalInfo : ''}
                />
            </Collapse>
        </div>
    )
}